import { Component, Input, OnInit, ViewChild, EventEmitter, Output, HostBinding } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { SolutionService } from '../../service/solution.service';
import { InputGroupControl } from '../../entity/controltype/input-group/inputgroupcontrol';
import { InputGroupValue } from '../../entity/conditionvalue/inputgroup';
import { InputGroupComponent } from '@farris/ui-input-group';


@Component({
    selector: 'app-filter-inputgroup',
    templateUrl: './inputgroup.component.html',
})

export class FilterInputGroupComponent implements OnInit {
    /**
     * QueryCondition类型
     */
    _inputItem: QueryCondition;

    testId: string;

    usageMode: string;

    dialogOptions: any;

    @Input()
    set item(textItem: any) {
        this._inputItem = textItem;
    }
    get item(): any {
        return this.constructTextItem(this._inputItem);
    }
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;

    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    @Output('searchHandle') searchHandle = new EventEmitter();

    @ViewChild('inputgroup') inputgroup: InputGroupComponent;

    textField: string;
    isTextFromDialog = false;
    textFormDialog: string;

    constructTextItem(textItem: QueryCondition): QueryCondition {
        const textValueObj = textItem.value as InputGroupValue;
        textValueObj.textValue = textValueObj.textValue && textValueObj.textValue.trim();
        textItem.value = textValueObj;
        return textItem;
    }

    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        this.testId = this.solutionService.getGuid();
        this.getInputGroupBindingInfo();

        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }
        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);
    }

    getInputGroupBindingInfo() {
        const inputGroupControl = (this.item.control as InputGroupControl);
        this.usageMode = inputGroupControl.usageMode;
        if (this.usageMode == 'open-modal' || this.usageMode == 'open-remote-modal') {
            this.dialogOptions = inputGroupControl.dialogOptions;
            /*
                example of dialogOptions = {
                   modalId: "1e011720-eb0f-4c9c-82b6-6844c89b2303"
                   mapFields: {hDepartment: "Name"}
                   title: "测试标题栏"
                   width: 800
                   height: 600
                }
             */
            if (this.dialogOptions.mapFields) {
                this.textField = JSON.stringify(this.dialogOptions.mapFields).split('"')[1];
            }
        }
    }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    /*
        dialogOptions = {
            modalId: "ae011720-eb0f-4c9c-82b6-6844c89b2303"
            mapFields: {hDepartment: "Name"}
            title: "测试标题栏"
            width: 800
            height: 600
            showButtons: true
            buttons: [
                { text: "确定", cls: "btn-primary", handle: _this.viewModel.rootviewmodelconfirm1 },
                { text: "取消", cls: "btn-secondary", handle: _this.viewModel.rootviewmodelcancel1}
            ]
        }
    */
    onClick(event: any) {
        if (this.usageMode == 'text') {
            this.item.control.click();
        }
        else {
            const options = this.dialogOptions;
            options.handle = (selectedItem) => {
                // let modalData = item[0];
                // this.item.value.value = modalData[this.targetField];
                let selectedItems = selectedItem.filter(n => n);
                if (selectedItems && this.textField) {
                    this.item.value.value = selectedItems;
                    this.item.value.textValue = this.item.value.getTextValue(this.textField);
                    this.item.value.textField = this.textField;
                    this.item.value.isInputText = false;
                    if (this.inputgroup) {
                        this.inputgroup.cd.detectChanges();
                        this.inputgroup.value = this.item.value.textValue;
                    }
                    this.isTextFromDialog = true;
                    this.textFormDialog = this.item.value.textValue;
                    this.onBlur();
                }
            }
            this.item.control.click({ event, options });
        }
    }

    onBlur() {
        if (this.disabled) { return; }
        if (this.usageMode == 'text') {
            this.item.value.isInputText = true;
        }
        if (this.usageMode == 'open-modal' || this.usageMode == 'open-remote-modal') {
            if (!this.isTextFromDialog) {
                this.item.value.isInputText = true;
            }
            if (this.item.value.textValue != this.textFormDialog) {
                this.isTextFromDialog = false;
                this.item.value.value = [];
                this.item.value.textField = undefined;
                this.item.value.isInputText = true;
            }
        }
        this.searchHandle.emit();
    }

    onClear() {
        (this.item.value as InputGroupValue).clearValue();
        this.searchHandle.emit();
    }
}